(function () {
  'use strict';

  var loading = false;
  var observer = null;
  var pageCache = new Map();
  var prefetchTimer = null;

  function getGrid(root) {
    return (root || document).querySelector('#productGrid');
  }

  function getPagination(root) {
    return (root || document).querySelector('.pagination');
  }

  function getNextLink(root) {
    return (root || document).querySelector('.pagination .next a');
  }

  function getLoader() {
    return document.getElementById('BHInfiniteScrollLoader');
  }

  function createLoader() {
    var existing = getLoader();

    if (existing) {
      return existing;
    }

    var pagination = getPagination();

    if (!pagination || !pagination.parentNode) {
      return null;
    }

    var loader = document.createElement('div');

    loader.id = 'BHInfiniteScrollLoader';

    loader.innerHTML =
      '<div class="bh-infinite-spinner"></div>' +
      '<div class="bh-infinite-text">Loading more products...</div>';

    pagination.parentNode.insertBefore(loader, pagination);

    return loader;
  }

  function hidePagination() {
    var pagination = getPagination();

    if (pagination) {
      pagination.style.display = 'none';
    }
  }

  function showPagination() {
    var pagination = getPagination();

    if (pagination) {
      pagination.style.display = '';
    }
  }

  function showEndMessage(grid) {
    if (
      !grid ||
      !grid.parentNode ||
      document.getElementById('BHInfiniteScrollEnd')
    ) {
      return;
    }

    var endMessage = document.createElement('div');

    endMessage.id = 'BHInfiniteScrollEnd';
    endMessage.textContent = "You've reached the end";

    grid.parentNode.appendChild(endMessage);
  }

  function stop(showFallback) {
    if (observer) {
      observer.disconnect();
      observer = null;
    }

    var loader = getLoader();

    if (loader) {
      loader.remove();
    }

    if (showFallback) {
      showPagination();
    } else {
      hidePagination();
    }
  }

  function fetchPage(url) {
    if (!url) {
      return Promise.reject(new Error('No URL supplied'));
    }

    if (pageCache.has(url)) {
      return pageCache.get(url);
    }

    var request = fetch(url, {
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('HTTP ' + response.status);
      }

      return response.text();
    }).catch(function (error) {
      pageCache.delete(url);
      throw error;
    });

    pageCache.set(url, request);

    return request;
  }

  function prefetchNextPage() {
    clearTimeout(prefetchTimer);

    prefetchTimer = setTimeout(function () {
      var nextLink = getNextLink();

      if (!nextLink || !nextLink.href) {
        return;
      }

      /*
       * Download the next collection page before the
       * customer actually reaches the bottom.
       */
      fetchPage(nextLink.href).catch(function () {
        /*
         * Ignore prefetch errors.
         * Normal infinite scroll can retry later.
         */
      });
    }, 0);
  }

  function reinitializeNewProducts(items) {
    if (!items || !items.length) {
      return;
    }

    try {
      if (
        window.theme &&
        typeof window.theme.reinitProductGridItem === 'function'
      ) {
        /*
         * Only initialise newly-added product cards.
         * Do not run through page 1 again.
         */
        items.forEach(function (item) {
          window.theme.reinitProductGridItem(item);
        });
      }
    } catch (error) {
      console.warn(
        'Product grid re-init skipped:',
        error
      );
    }

    /*
     * Help lazysizes detect dynamically-added images.
     */
    try {
      if (
        window.lazySizes &&
        window.lazySizes.loader &&
        typeof window.lazySizes.loader.checkElems === 'function'
      ) {
        window.lazySizes.loader.checkElems();
      }
    } catch (error) {
      console.warn(
        'Lazyload refresh skipped:',
        error
      );
    }
  }


  async function loadNextPage() {
    if (loading) {
      return;
    }

    var grid = getGrid();
    var nextLink = getNextLink();
    var loader = getLoader();

    if (!grid) {
      stop(true);
      return;
    }

    if (!nextLink || !nextLink.href) {
      stop(false);
      showEndMessage(grid);
      return;
    }

    var nextUrl = nextLink.href;

    loading = true;

    if (observer && loader) {
      observer.unobserve(loader);
    }

    if (loader) {
      loader.classList.add('is-loading');
    }

    try {
      /*
       * If prefetch already downloaded this page,
       * this resolves immediately from the cache.
       */
      var html = await fetchPage(nextUrl);

      var doc = new DOMParser().parseFromString(
        html,
        'text/html'
      );

      var incomingGrid = getGrid(doc);
      var incomingPagination = getPagination(doc);

      if (!incomingGrid) {
        throw new Error('Next product grid not found');
      }

      var fragment = document.createDocumentFragment();
      var newItems = [];

      Array.from(incomingGrid.children).forEach(function (item) {
        var importedItem = document.importNode(
          item,
          true
        );

        newItems.push(importedItem);
        fragment.appendChild(importedItem);
      });

      grid.appendChild(fragment);

      /*
       * Reinitialise only the newly inserted products.
       */
      reinitializeNewProducts(newItems);

      var currentPagination = getPagination();

      if (
        currentPagination &&
        incomingPagination
      ) {
        currentPagination.innerHTML =
          incomingPagination.innerHTML;

        currentPagination.style.display = 'none';
      }

      loading = false;

      if (loader) {
        loader.classList.remove('is-loading');
      }

      if (!getNextLink()) {
        stop(false);
        showEndMessage(grid);
        return;
      }

      /*
       * Start downloading the page after this one
       * immediately.
       */
      prefetchNextPage();

      if (observer && loader) {
        observer.observe(loader);
      }

    } catch (error) {
      console.error(
        'British House infinite scroll failed:',
        error
      );

      loading = false;

      if (loader) {
        loader.classList.remove('is-loading');
      }

      stop(true);
    }
  }

  function init() {
    var grid = getGrid();
    var nextLink = getNextLink();

    if (!grid) {
      return;
    }

    if (!nextLink) {
      hidePagination();
      showEndMessage(grid);
      return;
    }

    var loader = createLoader();

    if (!loader) {
      return;
    }

    hidePagination();

    /*
     * Begin downloading page 2 almost immediately
     * after page 1 has loaded.
     */
    prefetchNextPage();

    observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];

        if (
          entry &&
          entry.isIntersecting &&
          !loading
        ) {
          loadNextPage();
        }
      },
      {
        root: null,

        /*
         * Start inserting the next page much earlier.
         * Old value was only 300px.
         */
        rootMargin: '2200px 0px',

        threshold: 0
      }
    );

    observer.observe(loader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }
})();